module.exports = {"transactionType":{"name":null},"dealType":{"name":null,"description":null},"propertyType":{"name":null}}


//////////////////
// WEBPACK FOOTER
// ./src/components/new_deal/resources/basicData.json
// module id = K+kE
// module chunks = 1